(function($, Drupal) {
  'use strict';

  Drupal.behaviors.socialLinks = {
    attach: function(context, settings) {
      let $footer_links = $('.field--name-field-footer-links a');

      let social_media = [
        'linkedin',
        'instagram',
        'facebook',
        'youtube',
        'twitter'
      ];

      // Update social items with class
      $($footer_links).each(function() {
        let $button_link = $(this).attr('href').toString();
        for (let i = 0; i < social_media.length; i++) {
          if ($button_link.includes(social_media[i])) {
            $(this).parent().addClass('social-item');
          }
        }
        $('.social-item').first().prev().addClass('field__item-last');
      });
    }
  };
})(jQuery, Drupal);
